// Colour tokens for the admin video screen.
//
// These deliberately do NOT live in the global MUI theme. The player mounts
// MUI Tooltip/Menu/MenuItem (player/VideoPlayer.tsx:29-31) and those popups
// float over dark video, so anything put in the shared theme to suit a light
// admin page lands on the player's overlay UI too. Keeping the admin's palette
// local means restyling this screen cannot repaint a control-bar tooltip.
//
// The vocabulary itself is not new: prose face, ink and the jade/alarm accent
// pair are the ones fixed in verification/verificationTheme.ts, resolved for a
// light surface instead of a dark one.
export const ink = {
  ground: '#F4F7F8',
  card: '#FFFFFF',
  primary: '#08131A',
  secondary: '#5B6D76',
  tertiary: '#8497A0',
  rule: '#E1E8EA',
  ruleStrong: '#CBD6DA',
  jade: '#3FBF9B',
  jadeText: '#1F7A62',
  jadeTint: '#E4F5EF',
  alarm: '#FF5238',
  alarmText: '#C0341F',
  alarmTint: '#FFEDE9',
  neutralTint: '#EDF2F3',
} as const

export const prose = '"Open Sans", ui-sans-serif, system-ui, sans-serif'

// The player mounted inside the admin screen must not be laid out narrower
// than this. The control bar centres a fixed 180px skip cluster between two
// flex zones, so the wider of the two side clusters is paid for twice:
//
//   W_min = 16 padding + 2 gaps + 2 x max(left, right) + 180 centre
//
// The admin mount's right cluster is four buttons — it passes no verification
// slot, and the 360 button renders in quadrant view only — which puts W_min at
// roughly 688. 700 clears it by 12px and nothing more, so this is a floor to
// respect rather than a starting point to trim. If the admin mount ever gains
// the verification glyph or the 360 control, W_min jumps to ~916 and the pane
// layout has to change. Owned by the player workstream; see T10/T17 in
// docs/plans/2026-09-09-bbc-player-redesign.md.
export const MIN_ADMIN_PLAYER_WIDTH = 700
